import { NotifyHelper } from "../../../helpers/toast";
import { eLoaiChungChiActionsObj } from "../../action-types/category/ILoaiChungChiActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const loaiChungChiActions = {
    ...generateActions(eLoaiChungChiActionsObj, "LOAI_CHUNG_CHI"),
    ...generateActionForKey(eLoaiChungChiActionsObj, "LOAI_CHUNG_CHI", "SAVE_SUCCESS", () => { NotifyHelper.Success("Thành công") }),
    ...generateActionForKey(eLoaiChungChiActionsObj, "LOAI_CHUNG_CHI", "DELETE_SUCCESS", () => { NotifyHelper.Success("Thành công") }),
    ...generateActionForKey(eLoaiChungChiActionsObj, "LOAI_CHUNG_CHI", "SAVE_ERROR", (m) => { NotifyHelper.Error(m) }),
    ...generateActionForKey(eLoaiChungChiActionsObj, "LOAI_CHUNG_CHI", "DELETE_ERROR", (m) => { NotifyHelper.Error(m) }),
}